import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UpdateDocumentaryResourceBody } from "@shared-kernel/domain/types/documentary-resource";

export const documentaryResourceUpdate = createAsyncThunk<string, UpdateDocumentaryResourceBody, { extra: Partial<Dependencies> }>(
  "documentaryResource/update",
  async (body: UpdateDocumentaryResourceBody, { extra: { adminRepository } }) => {
    await adminRepository!.updateDocumentaryResource(body);
    return body.resourceId;
  },
);

export const documentaryResourceUpdateReset = createAction("documentaryResource/updateReset");
